import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import App from './App.tsx';
import '@fontsource-variable/plus-jakarta-sans';
import './index.css';
import { configureMonacoWorkers } from './utils/monaco-workers';
import { initializeAxe } from './lib/axe-config';

// Configure Monaco Editor workers before app initialization
configureMonacoWorkers();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
    <Toaster
      position="bottom-left"
      expand={false}
      richColors={true}
      closeButton={true}
      duration={3000}
      className="font-sans"
      toastOptions={{
        style: { maxWidth: '280px' },
      }}
    />
  </StrictMode>,
);

// Initialize automated accessibility testing (development only)
initializeAxe();
